import {
  GET_MESSAGEMANAGER_LIST, GET_MESSAGEMANAGER_LIST_FAILURE, GET_MESSAGEMANAGER_LIST_SUCCESS,
  GET_MESSAGEOFFICER_LIST, GET_MESSAGEOFFICER_LIST_FAILURE, GET_MESSAGEOFFICER_LIST_SUCCESS,
  GET_MESSAGEHARASSMENT_LIST, GET_MESSAGEHARASSMENT_LIST_FAILURE, GET_MESSAGEHARASSMENT_LIST_SUCCESS,
  GET_MESSAGEMANAGER_DETAIL, GET_MESSAGEMANAGER_DETAIL_FAILURE, GET_MESSAGEMANAGER_DETAIL_SUCCESS,
  GET_MESSAGEOFFICER_DETAIL, GET_MESSAGEOFFICER_DETAIL_FAILURE, GET_MESSAGEOFFICER_DETAIL_SUCCESS,
  GET_MESSAGEHARASSMENT_DETAIL, GET_MESSAGEHARASSMENT_DETAIL_FAILURE, GET_MESSAGEHARASSMENT_DETAIL_SUCCESS,
  UPDATE_MESSAGEMANAGER_READ, UPDATE_MESSAGEMANAGER_READ_FAILURE, UPDATE_MESSAGEMANAGER_READ_SUCCESS,
  UPDATE_MESSAGEOFFICER_READ, UPDATE_MESSAGEOFFICER_READ_FAILURE, UPDATE_MESSAGEOFFICER_READ_SUCCESS,
  UPDATE_MESSAGEHARASSMENT_READ, UPDATE_MESSAGEHARASSMENT_READ_FAILURE, UPDATE_MESSAGEHARASSMENT_READ_SUCCESS,
  MESSAGE_KEYWORD_SEARCH, MESSAGE_KEYWORD_SEARCH_FAILURE, MESSAGE_KEYWORD_SEARCH_SUCCESS

} from './mutation-types'

export default {
  state: {
    messages: [],
    messageDetail: [],
    shops: null,
    users: null
  },
  getters: {
    messages: state => {
      return state.messages
    },
    messageDetail: state => {
      return state.messageDetail
    },
    messageKeywordShops: state => {
      return state.shops
    },
    messageKeywordUsers: state => {
      return state.users
    }
  },
  actions: {
    [GET_MESSAGEMANAGER_LIST] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/messages/manager'
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_MESSAGEMANAGER_LIST_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(GET_MESSAGEMANAGER_LIST_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MESSAGEOFFICER_LIST] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/messages/officer'
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_MESSAGEOFFICER_LIST_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(GET_MESSAGEOFFICER_LIST_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MESSAGEHARASSMENT_LIST] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/messages/harassment'
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_MESSAGEHARASSMENT_LIST_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(GET_MESSAGEHARASSMENT_LIST_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MESSAGEMANAGER_DETAIL] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/messages/manager_detail'
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_MESSAGEMANAGER_DETAIL_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(GET_MESSAGEMANAGER_DETAIL_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MESSAGEOFFICER_DETAIL] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/messages/officer_detail'
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_MESSAGEOFFICER_DETAIL_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(GET_MESSAGEOFFICER_DETAIL_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_MESSAGEHARASSMENT_DETAIL] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/messages/harassment_detail'
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_MESSAGEHARASSMENT_DETAIL_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(GET_MESSAGEHARASSMENT_DETAIL_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [UPDATE_MESSAGEMANAGER_READ] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/messages/manager_read'
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(UPDATE_MESSAGEMANAGER_READ_FAILURE, res.data)
          } else {
            commit(UPDATE_MESSAGEMANAGER_READ_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [UPDATE_MESSAGEOFFICER_READ] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/messages/officer_read'
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(UPDATE_MESSAGEOFFICER_READ_FAILURE, res.data)
          } else {
            commit(UPDATE_MESSAGEOFFICER_READ_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [UPDATE_MESSAGEHARASSMENT_READ] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/messages/harassment_read'
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(UPDATE_MESSAGEHARASSMENT_READ_FAILURE, res.data)
          } else {
            commit(UPDATE_MESSAGEHARASSMENT_READ_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MESSAGE_KEYWORD_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/asovi/messages/keyword'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MESSAGE_KEYWORD_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MESSAGE_KEYWORD_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    POST_MESSAGEMANAGER_REPLY ({dispatch, state, commit}, params) {
      var data = params.data
      var url = '/asovi/messages/reply'
      var callback = params.callback || (() => {})
      dispatch('apiPost', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            alert('返信の送信に失敗しました: ' + res.data.error)
          } else {
            callback()
          }
        }
      })
      .catch(error => {
        console.log(error)
        alert('返信の送信に失敗しました')
      })
    }
  },
  mutations: {
    [GET_MESSAGEMANAGER_LIST_FAILURE] (state, params) {
      console.log('GET_MESSAGEMANAGER_LIST_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEMANAGER_LIST_SUCCESS] (state, params) {
      console.log('GET_MESSAGEMANAGER_LIST_SUCCESS')
      var data = params.data
      state.messages = data.data
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEOFFICER_LIST_FAILURE] (state, params) {
      console.log('GET_MESSAGEOFFICER_LIST_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEOFFICER_LIST_SUCCESS] (state, params) {
      console.log('GET_MESSAGEOFFICER_LIST_SUCCESS')
      var data = params.data
      state.messages = data.data
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEHARASSMENT_LIST_FAILURE] (state, params) {
      console.log('GET_MESSAGEHARASSMENT_LIST_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEHARASSMENT_LIST_SUCCESS] (state, params) {
      console.log('GET_MESSAGEHARASSMENT_LIST_SUCCESS')
      var data = params.data
      state.messages = data.data
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEMANAGER_DETAIL_FAILURE] (state, params) {
      console.log('GET_MESSAGEMANAGER_DETAIL_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEMANAGER_DETAIL_SUCCESS] (state, params) {
      console.log('GET_MESSAGEMANAGER_DETAIL_SUCCESS')
      var data = params.data
      state.messageDetail = data.data
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEOFFICER_DETAIL_FAILURE] (state, params) {
      console.log('GET_MESSAGEOFFICER_DETAIL_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEOFFICER_DETAIL_SUCCESS] (state, params) {
      console.log('GET_MESSAGEOFFICER_DETAIL_SUCCESS')
      var data = params.data
      state.messageDetail = data.data
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEHARASSMENT_DETAIL_FAILURE] (state, params) {
      console.log('GET_MESSAGEHARASSMENT_DETAIL_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_MESSAGEHARASSMENT_DETAIL_SUCCESS] (state, params) {
      console.log('GET_MESSAGEHARASSMENT_DETAIL_SUCCESS')
      var data = params.data
      state.messageDetail = data.data
      if (params.callback) {
        params.callback()
      }
    },
    [UPDATE_MESSAGEMANAGER_READ_FAILURE] (state, params) {
      console.log('UPDATE_MESSAGEMANAGER_READ_FAILURE')
    },
    [UPDATE_MESSAGEMANAGER_READ_SUCCESS] (state, params) {
      console.log('UPDATE_MESSAGEMANAGER_READ_SUCCESS')
    },
    [UPDATE_MESSAGEOFFICER_READ_FAILURE] (state, params) {
      console.log('UPDATE_MESSAGEOFFICER_READ_FAILURE')
    },
    [UPDATE_MESSAGEOFFICER_READ_SUCCESS] (state, params) {
      console.log('UPDATE_MESSAGEOFFICER_READ_SUCCESS')
    },
    [UPDATE_MESSAGEHARASSMENT_READ_FAILURE] (state, params) {
      console.log('UPDATE_MESSAGEHARASSMENT_READ_FAILURE')
    },
    [UPDATE_MESSAGEHARASSMENT_READ_SUCCESS] (state, params) {
      console.log('UPDATE_MESSAGEHARASSMENT_READ_SUCCESS')
    },
    [MESSAGE_KEYWORD_SEARCH_FAILURE] (state, data) {
      console.log('MESSAGE_KEYWORD_SEARCH_FAILURE')
    },
    [MESSAGE_KEYWORD_SEARCH_SUCCESS] (state, data) {
      console.log('MESSAGE_KEYWORD_SEARCH_SUCCESS')
      state.shops = data.data.shops.data
      state.users = data.data.users.data

      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js